export const attendees = [
	{id: 1, value: 500, label: "0 - 500", checked: false},
	{id: 2, value: 1500, label: "500 - 1.5k", checked: false},
	{id: 3, value: 5000, label: "1.5k - 5k", checked: false},
	{id: 4, value: 10000, label: "5k - 10k", checked: false},
	{id: 5, value: 25000, label: "10k - 25k", checked: false},
	{id: 6, value: 50000, label: "25k - 50k", checked: false},
	{id: 7, value: 1000000, label: "50k+", checked: false},
]

export const features = [
	{id: 20, value: "analytics", label: "Analytics"},
	{id: 21, value: "breakout_rooms", label: "Breakout Rooms"},
	{id: 23, value: "custom_branding", label: "Custom Branding"},
	{id: 24, value: "expo_and_vendor_booths", label: "Expo & Vendor Booths"},
	{id: 25, value: "live_streaming", label: "Live Streaming"},
	{id: 26, value: "local_time_zone_support", label: "Timezone Support"},
	{id: 27, value: "networking", label: "Networking"},
	{id: 28, value: "polling", label: "Polling"},
	{id: 29, value: "q&a", label: "Q&A"},
	{id: 30, value: "registration", label: "Registration"},
	{id: 31, value: "social_media_feed", label: "Social Media Feed"},
	{id: 32, value: "sponsorship", label: "Sponsorship"},
]

export const eventView = [
	{id: 33, value: "web_based", label: "Web-based",checked: false},
	{id: 34, value: "app_based", label: "App-based", checked: false},
	{id: 35, value: "both", label: "Both", checked: false},
]

export const eventType = [
	{id: 36, value: "appearanceOrSigning", label: "APPEARANCE OR SIGNING", checked: false},
	{id: 37, value: "attraction", label: "ATTRACTION", checked: false},
	{id: 38, value: "awards", label: "AWARDS", checked: false},
	{id: 39, value:"conferences", label: "CONFERENCES", checked: false},
	{id: 40, value: "concertOrPerformance", label: "CONCERT OR PERFORMANCE", checked: false},
	{id: 41, value: "courseTrainingOrWorkshop", label: "COURSE TRAINING OR WORKSHOP", checked: false},
	{id: 42, value: "dinnerOrGala", label: "DINNER OR GALA", checked: false},
	{id: 43, value: "fundraiser", label: "FUNDRAISER", checked: false},
	{id: 44, value: "festivalOrFair", label: "FESTIVAL OR FAIR", checked: false},
	{id: 45, value: "gameOrCompetition", label: "GAME OR COMPETITION", checked: false},
	{id: 46, value: "meetingOrNetwork", label: "MEETING OR NETWORK", checked: false},
	{id: 47, value: "partyOrSocialGathering", label: "PARTY OR SOCIAL GATHERING", checked: false},
	{id: 48, value: "pressRelease", label: "PRESS RELEASE", checked: false},
	{id: 49, value: "productLaunch", label: "PRODUCT LAUNCH", checked: false},
	{id: 50, value: "raceOrEndurance", label: "RACE OR ENDURANCE", checked: false},
	{id: 51, value: "seminarOrTalk", label: "SEMINAR OR TALK", checked: false},
	{id: 52, value: "teamBuilding", label: "TEAM BUILDING", checked: false},
	{id: 53, value: "tournament", label: "TOURNAMENT", checked: false},
	{id: 54, value: "tradeshowOrExpo", label: "TRADESHOW OR EXPO", checked: false},
	{id: 55, value: "other", label: "OTHER", checked: false},
]

export const exhibitors = [
	{id: 56, value: "true", label: "Yes", checked: false},
	{id: 57, value: "false", label: "No", checked: false},
]

export const eventTimeFrame = [
	{id: 58, value: "one_off", label: "One-off", checked: false},
	{id: 59, value: "recurring", label: "Recurring", checked: false},
]

export const eventFormats = [
	{id: 60, value: "virtual", label: "VIRTUAL"},
	{id: 61, value: "hybrid", label: "HYBRID"},
	// {id: 3, value: "live", label: "LIVE"},
]
